<template>
	<!--	:name="vpEtikett"-->
	<!-- '#default' nedan = 'v-slot:default' = nya sättet att sätta 'slot-scope' och kallas 'slot props' (slotProps): -->
	<validation-provider ref="validationProvider"
		tag="div"
		mode="eagerMedBlurOchDebounce"
		:rules="vpValidationRules"
		#default="{ valid, errors, failedRules, flags }"
		class="_eui-form_textruta_validation-provider"
	>
		<div
			class="_eui-form_textruta"
			:class="[ vpClass, {
				'-obligatorisk':arRequired && !vpIndikeraInteObligatorisk,
				'-losen':arLosen && !vpReadOnly,
				'-readonly':vpReadOnly,
				'-osynlig':skaVaraOsynlig,
				'-invalid':flags.validated && !valid,
			}]"
			:style="vpStyle"
			:disabled="skaVaraInaktiverad"
		>
			<label
				:for="uniktId"
				:title="vpTooltip"
				class="_eui-form_textruta_etikett"
				:class="{
					fore:true,
					'-readonly':vpReadOnly,
				}"
				:style="{ 'max-width':vpEtikettbreddMedEnhet }"
				v-html="vpEtikett + ':'"
			></label>

			<div class="_eui-form_textruta_rutyta"
				:style="{ 'max-width':vpRutbreddMedEnhet }"
			>
				<!--
					– VeeValidate: The fields being validated *must have a v-model* so the component can correctly identify the element/component being validated.
					v-model.trim="innerValue"
				-->
				<!--	Denna sabbar och orsakar att v-model-värdet ibland tillfälligt sätts till [InputEvent ..]. Det kan vara så att den omslutande validation-provider (top node för hela denna komponenten) jobbar med egna eventlyssnare och att den inte mår så bra av att de flyttas in till input???
					v-on="$listeners"-->
				<input ref="inputelementet"
					:id="uniktId"
					:type="inputType"
					:name="uniktId + '-name'"
					v-model="innerValue"
					:placeholder="!vpReadOnly && vpPlaceholder"
					:autofocus="vpAutofocus"
					spellcheck="false"
					:disabled="skaVaraInaktiverad || vpReadOnly"
					:class="{
						'-readonly':vpReadOnly,
					}"

					@keydown.enter="onEnterTryckt()"
					@keydown.esc="onEscTryckt()"

					v-bind="$attrs"
				>

				<!-- ##### Toggla synlighet-knapp (lösen): -->
				<!-- Som en quick-fix för lösenordshanterare som injekterar saker sist i input (och inte tar hänsyn till ev paddning) så flyttar jag ut knappen till höger om input. Dock så hamnar den då *utanför* komponentens yttre ramar, så det får man ta hänsyn till i containrar etc!
					right: 0; -->
				<eui-knapp v-if="arLosen"
					vp-css-modifier-class="-transparent"
					@tryckt="onTogglaSynlighet()"
					style="
						width: 1.6em;
						height: 1.6em;
						padding: 0.2em;
						border-radius: 100%;
						position: absolute;
						top: 0;
						right: -1.6em;
						line-height: 0;
					"
				>
					<eui-modifierad-svg v-show="losenArSynligt"
						vp-ikon="doljLosen"
					></eui-modifierad-svg>
					<eui-modifierad-svg v-show="!losenArSynligt"
						vp-ikon="visaLosen"
					></eui-modifierad-svg>
				</eui-knapp>


				<!--<div class="-rod-text">{{ errors.first('email') }}</div>-->

				<!--<transition name="el-zoom-in-left">-->
				<div class="_eui-form_textruta_feltext">
					<div class="ellipsis" v-html="errors[0]">
						<!--{{ errors[0] }}-->
					</div>
				</div>
				<!--</transition>-->

			</div>

		</div>
	</validation-provider>
</template>



<script>
	//#####################################################################################

	import Vue from 'vue';
	import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
	import { ValidationProvider } from 'vee-validate';
	import euiKnapp from 'v-components/euiKnapp';
	import euiModifieradSvg from 'v-components/euiModifieradSvg';

	import VeeValidateInstanceMedRattOptions from 'VeeValidateInstanceMedRattOptions';
	VeeValidateInstanceMedRattOptions.runOnce();		// Kör funktionen om den inte redan körts!

	// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
	let uniktIdCounter = 0;


	export default {

		name: 'eui-form-textruta',

		mixins: [euiLifecycleStatusesMixin],

		components: {
			'validation-provider': ValidationProvider,
			euiKnapp,
			euiModifieradSvg,
		},

		// Denna infördes enkom för att få bättre koll event-/reaktuivitets-/watch-flödena (vid en felsökning). Låter dock vara så:
		model: {
			// use `outerValue` as the prop which take the place of `value`. This allows using the `value` prop for a different purpose:
			// Obs! Går emot rekommendation på https://blog.webf.zone/vue-js-forms-components-and-considerations-d81b3ffe9efb!
			prop: 'outerValue',
			event: 'input'
		},

		props:
		{
			// must be included in props
			outerValue: {
				type: String,	//null,
				default: '',
			},

			//vpInputName: {		// Blir name-attributet på inputen och även key i FormData.
			//	type: String,
			//	required: true
			//},

			vpInputType: {
				type: String,
				default: 'text'	// HTML5-värden för attributet 'type'.
			},

			vpPlaceholder: {
				type: String,
				default: undefined
			},

			vpAutofocus: {
				type: Boolean,
				default: false,
			},

			vpEtikett: {			// Får innehålla HTML.
				type: String,
				default: null,
			},
			vpEtikettbreddMedEnhet: {
				type: String,
				default: '7rem',
			},
			vpRutbreddMedEnhet: {
				type: String,
				default: '22rem',
			},

			vpIndikeraInteObligatorisk: {
				type: Boolean,
				default: false,
			},

			vpValidationRules: {
				type: [Object, String],
				default: '',
			},

			vpAccessKey: {
				type: String,
				default: null
			},
			vpTooltip: {
				type: String,			// Får innehålla HTML.
				default: null
			},

			vpReadOnly: {
				type: Boolean,
				default: false,
			},
			vpInaktiverad: {
				type: Boolean,
				default: false,
			},
			vpOsynlig: {
				type: Boolean,
				default: false,
			},

			vpClass: {
				type: String,
				default: null
			},
			vpStyle: {
				type: String,
				default: null
			},
		},

		data()
		{
			return {
				uniktId: 'eui-form-textruta-unikt-' + (++uniktIdCounter),
				innerValue: '',
				arLosen: this.vpInputType === 'password',
				//inputType: this.vpInputType,
				losenArSynligt: false,
			};
		},

		inheritAttrs: false,		// Attribut på komponenten ärvs inte till själva *komponentens* rot-element, utan ist till input-elementet, se template ovan. (Gäller *inte* class- och style-attributen!)

		computed: {
			arRequired()
			{
				return (!this.vpReadOnly && !this.skaVaraInaktiverad && !!this.vpValidationRules && !!(this.vpValidationRules.indexOf('required') !== -1));
			},

			inputType()
			{
				if (this.arLosen)
					return (this.losenArSynligt ? 'text' : 'password');

				return this.vpInputType;
			},
  
			skaVaraOsynlig()
			{
				return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedHasOccured);
			},
			skaVaraInaktiverad()
			{
				return (this.vpInaktiverad || !this.lifecycleStatuses.mixinMountedHasOccured);
			},
		},

		watch: {
			// Handles internal model changes.
			innerValue(nyttVarde, tidigareVarde)
			{
				//console.log('### watch innerValue: "' + nyttVarde + '" <- "' + tidigareVarde + '"');
				this.$emit('input', nyttVarde);	// Funka ej: .trim());
			},

			// Handles external model changes.
			outerValue(nyttVarde, tidigareVarde)
			{
				//// Todo: ! Tillfällig fix:
				//// Ibland, kanske pga validatorn, så fås en sådan här förändring (inloggningssidan, epost-fältet, tryck Mellanslag) *innan* innerValue ändras. Vid normala knapptryckningar ändras innerValue före denna (?):
				//if (nyttVarde instanceof Event)	// InputEvent
				//	this.innerValue = nyttVarde.target.value;
				//else
				//	this.innerValue = nyttVarde;	// Funka ej: .trim();

				console.assert(!nyttVarde || typeof nyttVarde === 'string',
					'v-model-värdet får endast sättas till ett värde av typen \'string\' (eller null/undefined).');

				this.innerValue = nyttVarde;	// Funka ej: .trim();
			},

			vpReadOnly(nyttVarde, tidigareVarde)
			{
				if (!nyttVarde)
				{
					// Om den ändrats från read-only –> ändringsbar:
					// Sätt ev autofocus:
					this.sattEventuellAutofocus();
				}
				else
				{
					// Om den ändrats från ändringsbar –> read-only:
					// Rensa ev selection i rutan (eller egentligen var som i dokumentet):
					document.getSelection().removeAllRanges();
				}
			},
		},

		methods: {
			onEnterTryckt() { this.$emit('enter-tryckt'); },
			onEscTryckt() { this.$emit('esc-tryckt'); },

			onTogglaSynlighet()
			{
				this.losenArSynligt = !this.losenArSynligt;
			},

			sattEventuellAutofocus()
			{
				// Sätt ev autofocus:
				if (this.vpAutofocus)
				{
					// Invänta, så att ev reaktiva ändringar (här, att inputelementet blir fokuserbart) hinner slå igenom först:
					Vue.nextTick(function () {
							this.$refs.inputelementet
								.focus();
							//.select();	// Även select. Eller?
							//move the cursor to the beginning of the text:
							//.setSelectionRange(0,0);
						}
						, this	// Vue.nextTick 'this' context.
					);
				}
			},
		},

		//== Lifecycle hooks  ================================================================================================================

		created()
		{
			if (this.outerValue)
			{
				this.innerValue = this.outerValue;
			}
		},

		mounted()
		{

			// Tips: Så här kan man kolla om Caps Lock är valt, om vi vill varna för det i lösen-fält (event = key-event, så det måsta man fånga. testat att funkar på keyDown i Chrome):
			//var caps = event.getModifierState && event.getModifierState('CapsLock');

			this.$nextTick(function() {
				// Sätt ev autofocus:
				this.sattEventuellAutofocus();
			});
		},

	}
</script>
